import agencyService from '@/services/agency';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    currentAgency: {},
  };
};
const state = initialState();
const getters = {
  currentAgency(state) {
    return state.currentAgency;
  },
};
const actions = {
  async getCurrentAgency({commit}, id) {
    const result = await agencyService.getAgencyById(id);
    commit('setCurrentAgency', result);
    return result;
  },
};
const mutations = {
  setCurrentAgency(state, data) {
    state.currentAgency = data;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
